module.exports = __webpack_public_path__ + "01_long_gold.32d0a751.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_long_gold.png
// module id = S7hm
// module chunks = 0